import humps from 'humps';
import mapParameters from '@/utils/map-parameters';
import BaseService from './base.service';
import backendV2Service from './backend-v2.service';

const baseService = new BaseService('klprior');

export default {
  findOneById: (priorId: number | string) => baseService.get(`findOne/${priorId}`),
  findOneByDNI: (dni: string) => baseService.get(`findOneByDni/${dni}`),

  getSalesAndActivationReport: (
    dateFrom: string,
    dateTo: string,
    excludingDemoData: boolean,
  ) => {
    const params = mapParameters({
      dateFrom,
      dateTo,
      excludingDemoData,
    });
    return backendV2Service.getFile('/prior-registration/sales-activation-report', {
      params: humps.decamelizeKeys(params.params),
    });
  },
};
